import * as colors from './colors';
import * as sizes from './sizes';
import * as spacing from './spacing';

export * from './flex';
export * from './font';
export * from './opacity';
export * from './z-indexes';
export { sizes, colors, spacing };
